import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Main';
import OnboardingHeader from './OnboardingHeader';

const RouteAwareHeader = () => {
    const location = useLocation();
    const isOnboardingRoute = location.pathname.startsWith('/onboarding/');
    const isCheckEmailPage = location.pathname === '/check-your-email';
    
    // Show onboarding header for both onboarding routes and check-your-email page
    if (isOnboardingRoute || isCheckEmailPage) {
        return <OnboardingHeader />;
    }
    
    return <Header />;
};

export default RouteAwareHeader;

